









































import Vue from "vue";
import moment from "moment";
import { RootState } from "@/store";
import { mapGetters, mapState } from "vuex";

import { Machine } from "@/model/data/Machine";

export default Vue.extend({
    props: {
        loading: Boolean,
        dateListString: Array,
        cserviceLogonList: Array,
        processedCashList: Array,
        startDate: Date,
        machine: Object as () => Machine,
        installationName: String,
        nDays: Number,
    },
    data() {
        return {
            showImageDialog: false,
            selectedException: undefined,
            loadingImage: false,
            seriesCSLTrendList: [],
            maxYValue: 0,
            moment,
        };
    },
    computed: {
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        ...mapGetters(["longDateFormat"]),
        chartCServiceLogonTrend() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "bar",
                        stacked: true,
                        height: 350,
                        zoom: {
                            enabled: false,
                        },
                        animations: {
                            enabled: false,
                        },
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: false,
                        },
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateListString,
                        tickPlacement: "on",
                    },
                    yaxis: {
                        labels: {
                            formatter: (val) => val.toFixed(0),
                        },
                        max: this.maxYValue + 1,
                    },
                },
                series: this.seriesCSLTrendList,
            };
        },
    },
    methods: {
        setRowStyle() {
            return "style-1";
        },
        reset() {
            this.seriesCSLTrendList = [];
            this.logonTableData = [];
            this.totalRowExceptionDataTable = 0;
            this.maxYValue = 0;
        },
    },
    watch: {
        cserviceLogonList: {
            handler(value) {
                this.reset();
                if (value && value.length) {
                    let cserviceLogonTrendMap = new Map<string, Array<number>>();
                    this.cserviceLogonList.forEach((csl) => {
                        let utcDate = Date.UTC(csl.dateTime.getFullYear(), csl.dateTime.getMonth(), csl.dateTime.getDate(), 0, 0, 0);
                        let dayIndex = Math.floor((utcDate - this.startDate.getTime()) / (1000 * 3600 * 24));
                        if (!cserviceLogonTrendMap.get(csl.userKId)) cserviceLogonTrendMap.set(csl.userKId, new Array<number>(this.nDays).fill(0));
                        cserviceLogonTrendMap.get(csl.userKId)[dayIndex] += 1;
                    });
                    let maxValue = Array(this.nDays).fill(0);
                    cserviceLogonTrendMap.forEach((value, key) => {
                        value.forEach((element, i) => {
                            maxValue[i] += element;
                        });
                        this.seriesCSLTrendList.push({ name: key, data: value });
                    });
                    this.maxYValue = Math.max(...maxValue);
                }
            },
            immediate: true,
            deep: true,
        },
    },
});
